import actions from './dashboard.actions';
import { dashboardMutations } from './dashboard.mutations';
import getters from './dashboard.getters';

// import { mutations } from './app.mutations';
export interface State {
  endpointsMeta: any[];
  instancesMeta: any[];
  endpointsTotal: any;
  instancesTotal: any;
  apdexEnabled: any;
  databaseStatements: any[];
  databaseStatementTotal: any;
  activeInstanceCount: any;
}

const initialState = () => ({
  currentTab: 'Service' || window.localStorage.getItem('tabName'),
  endpointsMeta: [],
  instancesMeta: [],
  endpointsTotal: 0,
  instancesTotal: 0,
  apdexEnabled: false,
  databaseStatements: [],
  databaseStatementTotal: 0,
  activeInstanceCount: 0
});

export default {
  namespaced: true,
  state: initialState,
  actions: actions,
  mutations: dashboardMutations,
  getters: getters
  // actions,
};
